// /choose-role: the web dual-role picker (FR-031; routes.md).
import { ChooseRoleScreen } from "@/auth/roles/ChooseRoleScreen";

export default function ChooseRole() {
  return <ChooseRoleScreen />;
}
